import React from 'react';
import CreateGameState from './createGameState/CreateGameState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';

const CreateGamePage: React.FC = () => {
	return (
		<CreateGameState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</CreateGameState>
	);
};

export default CreateGamePage;
